import { IdModal } from "../../../modals/IdModal";
import { createPathSelectTabInModal } from "../../../show-me/path/createPathSelectTabInModal";
import { IdStoreCategory } from "../../../store/IdStoreCategory";
export var pathSelectDollarPackagesInStoreMenu = function (action, state$, deps) {
    return createPathSelectTabInModal(function () { return IdModal.Store; }, function () { return IdStoreCategory.FarmDollarPackages; })(action, state$, deps);
};



//////////////////
// WEBPACK FOOTER
// ./src/features/info/inventory/paths/pathSelectDollarPackagesInStoreMenu.ts
// module id = 1909
// module chunks = 3